import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { getAllQuestionAnswerAction } from '../../redux/toolkit/question-answer/getAllQuestionAnswer'
import { deleteQuestionAnswerAction } from '../../redux/toolkit/question-answer/deleteQuestionAnswer'
import PropTypes from 'prop-types';

export default function ReStoreQns({ qns_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const restoreQns = useSelector(state => state.deleteQuestionAnswer)
    const { status, message } = restoreQns

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        await dispatch(deleteQuestionAnswerAction({qns_id:qns_id,is_delete:false}))
        await dispatch(getAllQuestionAnswerAction({ is_deleted: true }))
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Restore item request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to restore the selected question ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}

ReStoreQns.propTypes = {
    qns_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};